import React from 'react';

const PrototypeBanner: React.FC = () => (
  <div
    style={{
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      height: 36,
      background: 'var(--amber)',
      color: '#1a1200',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      fontFamily: 'Arial, sans-serif',
      fontSize: 12,
      fontWeight: 700,
      letterSpacing: '0.04em',
      zIndex: 9999,
      userSelect: 'none',
    }}
  >
    ⚠&nbsp;&nbsp;PROTOTYPE — FOR TESTING PURPOSES ONLY · NOT CLEARED FOR PII OR OFFICIAL USE&nbsp;&nbsp;⚠
  </div>
);

export default PrototypeBanner;
